export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-collection/src/values.js
// module id = ./node_modules/d3-collection/src/values.js
// module chunks = 1